import { Injectable } from '@angular/core';
import { App } from "@capacitor/app";
import { Capacitor } from "@capacitor/core";
import { User, UserSettings } from 'src/app/models/user';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class GlobalVar {

  // App environment variables
  public _version     = '0.0.0';
  public _name        = environment.APP_NAME;
  public _description = environment.APP_DESCRIPTION;
  public _domain      = environment.APP_DOMAIN;
  public _apiUrl      = environment.APP_ROOT_API;
  public _withCredentials = environment.APP_WITH_CREDENTIALS;
  public _imgUrl      = environment.APP_IMAGE_URL;
  public _noImgUrl    = environment.APP_NO_IMAGE_URL;
  public _toolbarName = environment.APP_TOOLBAR_APP_NAME;

  public _author      = environment.APP_AUTHOR;
  public _authorUrl   = environment.APP_AUTHOR_URL;

  public _appHasOnboarding = environment.APP_ONBOARDING;
  public _appHasAuthOverview = environment.APP_AUTH_OVERVIEW;

  // PUSHER settings
  public _pusherAppId   = environment.PUSHER ? environment.PUSHER_APP_ID : '';
  public _pusherKey     = environment.PUSHER ? environment.PUSHER_KEY : '';
  public _pusherSecret  = environment.PUSHER ? environment.PUSHER_SECRET : '';
  public _pusherCluster = environment.PUSHER ? environment.PUSHER_CLUSTER : '';


  public _storageAppKey = `${this._name}`;
  public _userKey       = 'USER';
  public _userToken     = 'TOKEN';

  // User data
  public _user: User;
  public _userSettings: UserSettings = new UserSettings;
  public _token;

  public _device;

  // API endpoints
  public _postLogin          = 'login';
  public _postRegister       = 'register';
  public _postForgotpswd     = 'request-password';
  public _postUpdateUser     = 'update-user';
  public _postUserSetting    = 'user-setting';
  public _getUserSettings    = 'user-settings';
  public _putProfilePicture  = 'update-profile-photo';
  public _postDeactivateUser = 'deletion-request-user';
  public _getOnboarding      = 'get-onboarding';
  public _postPusher         = 'send-message';
  public _getPusher          = 'get-messages';
  public _deletePusher       = 'delete-message';
  public _postFeedback       = 'create-feedback';
  public _getContact         = 'get-contact';
  public _getContacts        = 'get-contact';

  public _createBook         = 'create-book';
  public _putBook            = 'update-book';
  public _getBooks           = 'get-books';
  public _createChapter      = 'create-chapter';
  public _putChapter         = 'update-chapter';
  public _createCheckin      = 'create-checkin';
  public _putCheckin         = 'update-checkin';
  public _getCheckins        = 'get-checkins';
  public _getProtocols       = 'get-introduction';
  public _getAssignments     = 'get-assignments';
  public _putAssignment      = 'complete-assignment';
  public _postEvaluation     = 'create-evaluation';

  // Form verification patterns
  public _verificationEmail    = '[a-zA-Z0-9._]+[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}';
  public _verificationPassword = '^.{3,}$';
  public _verificationName     = '[a-zA-Z ]*';
  public _verificationPhone    = '^((\\+91-?)|0)?[0-9]{10}$';
  public _verificationStreet   = '[a-zA-Z0-9 \,\.\-]*';
  public _verificationZipcode  = '^[a-z0-9][a-z0-9\- ]{0,10}[a-z0-9]$';
  public _verificationCity     = '[a-zA-Z \,\.\-]*';
  public _verificationCountry  = '[a-zA-Z \,\.\-]*';
  public _verificationTextarea = '^.{0,}$';
  public _verificationNumber   = '^-?[0-9]*[.]?[0-9]+$';

  public notificationRoute = '';

  constructor() {
    this.initialize();
  }

  async initialize() {
    if (Capacitor.getPlatform() === 'web') {
      return;
    }

    const info = await App.getInfo();
    this._version = info.version;
  }
}
